<template lang="pug">
  div
    modal-change-status(:form="selectedProject" :isVisible="isModalChangeStatusVisible" @closeModal="closeModalChangeStatus" @submit="updateStatus" :is-add='isModalAdd')
    modal-projects(:form='selectedProject', :isAdd='isModalProjectsAdd' :isVisible="isModalProjectsVisible" @closeModal="closeModalProjects" @updateRecords="updateProjectsTable")
    modal-administratives(:form='selectedAdministrative' :isAdd='isModalAdministrativesAdd' :isVisible="isModalAdministrativesVisible" @closeModal="closeModalAdministratives" @updateRecords="updateAdministrativesTable")

    div.header_style#balance
      div.dashboard_title
        h2 {{ $t('strings.balance_sheet') }}
        img.title_icon(src="@/assets/balance.png")
    div
    div.statistics
      div.statistic
        div.side_color(style="background-color: #1cb7ff")
        span.statistic_text {{ $t('dashboard.balance')}}
        strong.statistic_number {{ balance.balance | currency }}
      div.statistic
        div.side_color(style="background-color: #15dd73")
        span.statistic_text {{ $t('dashboard.payable')}}
        strong.statistic_number {{ balance.pending_charges | currency }}
      div.statistic
        div.side_color(style="background-color: #ff6b00")
        span.statistic_text {{ $t('dashboard.receivable')}}
        strong.statistic_number {{ balance.pending_payment | currency }}
      div.statistic
        div.side_color(style="background-color: #5367ff")
        span.statistic_text {{ $t('dashboard.in_account')}}
        strong.statistic_number {{ balance.in_account | currency }}
    br
    h3 {{ $t('dashboard.projects') }}
    br
    vm-table.table(max-height="350px" :data="projects")
      template(slot="thead")
        vm-th(:key="index" v-if="projectColumn !== 'id'" v-for="(projectColumn, index) in projectColumns") {{ $t('projects.' + projectColumn) }}
      template(slot-scope="{data}")
        vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
          vm-td(:data="data[indextr][projectColumn]" :key="index" v-if="projectColumn !== 'id'" v-for="(projectColumn, index) in projectColumns")
              .detail(@click="goProjectDetail(data[indextr])")
                slot(v-if="projectColumn == 'charge' || projectColumn == 'payment'")  {{ data[indextr][projectColumn] | currency }}
                slot(v-if="projectColumn == 'finish_date'")  {{ data[indextr][projectColumn] == null ? '---- ---- ----' : data[indextr][projectColumn] | moment("DD MMMM YYYY") }}
                slot(v-if="projectColumn == 'created_at'")  {{ data[indextr][projectColumn] | moment("DD MMMM YYYY").toUpperCase() }}
                slot(v-if="projectColumn == 'total_price' || projectColumn == 'sale_cost'  || projectColumn == 'utility'")  {{ data[indextr][projectColumn] | currency }}
                slot(v-if="projectColumn !== 'status' && projectColumn !== 'price' && projectColumn !== 'finish_date' && projectColumn !== 'utility' && projectColumn !== 'created_at' && projectColumn !== 'charge' && projectColumn !== 'iva' && projectColumn !== 'total_price' && projectColumn !== 'sale_cost'" ) {{ projects[indextr][projectColumn] }}
                vm-status-indicator(v-if="projectColumn == 'status'" :pulse="true" :color="statusColor(data[indextr][projectColumn])") {{ data[indextr][projectColumn] === 1 ? $t('dashboard.active') : $t('dashboard.finished') }}
          vm-td
          vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
            vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
            vm-dropdown-menu(style="width: 12rem")
              vm-dropdown-item.d-flex.justify-content-between(@click="showModalChangeStatus(data[indextr])")
                vm-icon(icon="file-add-outline")
                slot &nbsp;{{ $t('strings.change_status') }}
              vm-dropdown-item.d-flex.justify-content-between(@click="showEditProject(data[indextr])")
                vm-icon(icon="edit-2-outline")
                slot &nbsp;{{ $t('strings.edit') }}
              vm-dropdown-item.d-flex.justify-content-between(@click="deleteProjectConfirm(data[indextr])")
                vm-icon(icon="trash-2-outline")
                slot &nbsp;{{ $t('strings.delete') }}
    vm-pagination(
    :total="projectsPagination.totalPages",
    v-model="currentPageProjects",
    goto)
    br
    h3 {{ $t('dashboard.administratives') }}
    br
    vm-table.table(max-height="350px" :data="administrativeConcepts")
      template(slot="thead")
        vm-th(:key="index" v-if="administrativeColumn !== 'id'" v-for="(administrativeColumn, index) in administrativeColumns") {{ $t('administrative_concepts.' + administrativeColumn) }}
      template(slot-scope="{data}")
        vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
          vm-td(:data="data[indextr][administrativeColumn]" :key="index" v-if="administrativeColumn !== 'id'" v-for="(administrativeColumn, index) in administrativeColumns")
            .detail(@click="goAdministrativeDetail(data[indextr])")
              slot(v-if="administrativeColumn  == 'expenses'")  {{ data[indextr][administrativeColumn] | currency }}
              slot(v-if="administrativeColumn == 'created_at'")  {{ data[indextr][administrativeColumn] | moment("DD MMMM YYYY").toUpperCase() }}
              slot(v-if="administrativeColumn !== 'status' && administrativeColumn !== 'conceptable_name' && administrativeColumn !== 'expenses' && administrativeColumn !== 'created_at' && administrativeColumn !== 'charge' && administrativeColumn !== 'payment' && administrativeColumn !== 'conceptable_type'") {{ data[indextr][administrativeColumn] }}
          vm-td
          vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
            vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
            vm-dropdown-menu
              vm-dropdown-item.d-flex.justify-content-between(@click="showEditAdministrative(data[indextr])")
                vm-icon(icon="edit-2-outline")
                slot &nbsp;{{ $t('strings.edit') }}
              vm-dropdown-item.d-flex.justify-content-between(@click="deleteAdministrativeConfirm(data[indextr])")
                vm-icon(icon="trash-2-outline")
                slot &nbsp;{{ $t('strings.delete') }}
    vm-pagination.pagination(
    :total="administrativeConceptsPagination.totalPages",
    v-model="currentPageAdministratives",
    goto)
</template>
<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Dashboard')
const ModalChangeStatus = () => import('@/components/modals/ModalChangeStatus.vue')
const ModalProjects = () => import('@/components/modals/ModalProjects.vue')
const ModalAdministratives = () => import('@/components/modals/ModalAdministrativeConcepts.vue')

export default {
  components: {
    ModalChangeStatus,
    ModalProjects,
    ModalAdministratives
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    currentPageProjects: 1,
    currentPageAdministratives: 1,
    projectColumns: ['created_at', 'finish_date', 'name', 'total_price', 'sale_cost', 'utility', 'status'],
    administrativeColumns: ['created_at', 'concept', 'expenses'],
    selectedProject: {},
    isModalChangeStatusVisible: false,
    attributeModal: 'name',
    isModalProjectsAdd: true,
    isModalProjectsVisible: false,
    selectedAdministrative: {},
    isModalAdministrativesAdd: true,
    isModalAdministrativesVisible: false
  }),
  computed: {
    ...mapGetters([
      'projects',
      'administrativeConcepts',
      'projectsPagination',
      'administrativeConceptsPagination',
      'balance'
    ])
  },
  watch: {
    async currentPageProjects (value) {
      this.loadProjects({ page: value })
    },
    async currentPageAdministratives (value) {
      this.loadAdministrativeConcepts({ page: value })
    }
  },
  async created () {
    await this.loadProjects({ page: this.currentPage })
    await this.loadAdministrativeConcepts({ page: this.currentPage })
    await this.loadBalance()
  },
  methods: {
    ...mapActions([
      'deleteRecord',
      'loadProjects',
      'loadAdministrativeConcepts',
      'loadBalance',
      'updateProject',
      'updateAdministrative',
      'editProject'
    ]),
    async refreshBalance () {
      await this.loadBalance()
    },
    showModalChangeStatus (project) {
      this.isModalAdd = false
      this.selectedProject = { ...project }
      this.isModalChangeStatusVisible = true
    },
    closeModalChangeStatus () {
      this.isModalChangeStatusVisible = false
    },
    statusColor (status) {
      return status === 1 ? 'success' : 'warning'
    },
    updateStatus (form) {
      this.editProject({ ...this.selectedProject, ...form })
    },
    async deleteProjectConfirm (record) {
      let t = this
      this.auxDeleteRecord = async () => {
        await t.deleteRecord({ ...record, route: 'projects', type: 'PROJECT' }).then(() => {
          t.selected = []
        })
        await t.refreshBalance()
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', {
          model: this.$t('strings.project'),
          attribute: this.$t(record[this.attributeModal])
        }),
        accept: this.auxDeleteRecord
      })
    },
    async deleteAdministrativeConfirm (record) {
      let t = this
      this.auxDeleteRecord = async () => {
        await t.deleteRecord({ ...record, route: 'administrative-concepts', type: 'ADMINISTRATIVE' }).then(() => {
          t.selected = []
        })
        await t.refreshBalance()
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation2', {
          model: this.$t('strings.administrative_concept'),
          attribute: this.$t(record[this.attributeModal])
        }),
        accept: this.auxDeleteRecord
      })
    },
    showEditProject (project) {
      this.selectedProject = { ...project, total_price: parseFloat(project.total_price).toFixed(2), price: parseFloat(project.price).toFixed(2) }
      this.isModalProjectsAdd = false
      this.isModalProjectsVisible = true
    },
    closeModalProjects () {
      this.isModalProjectsVisible = false
      this.selectedProject = {}
    },
    showEditAdministrative (administrative) {
      this.selectedAdministrative = { ...administrative }
      this.isModalAdministrativesAdd = false
      this.isModalAdministrativesVisible = true
    },
    closeModalAdministratives () {
      this.isModalAdministrativesVisible = false
      this.selectedAdministrative = {}
    },
    goProjectDetail (project) {
      this.$router.push({ name: 'project-detail', params: { id: project.id, origin: 'balance_sheet' } })
    },
    goAdministrativeDetail (administrative) {
      this.$router.push({ name: 'administrative-detail', params: { id: administrative.id, origin: 'balance_sheet' } })
    },
    updateAdministrativesTable () {
      setTimeout(async () => {
        await this.loadAdministrativeConcepts({ page: this.currentPage })
      }, 200)
    },
    updateProjectsTable () {
      setTimeout(async () => {
        await this.loadProjects({ page: this.currentPage })
      }, 200)
    }
  }
}
</script>
<style scoped lang="scss">
@import './dashboard_structure.css';
</style>
